// extracted by mini-css-extract-plugin
export default {"footerWrapper":"ProfileMenuFooter_footerWrapper--H4b","guest":"ProfileMenuFooter_guest--G5z"};